import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#419AE6",
			d: "M7 4h12.745l6.755 6.729V26.5A1.5 1.5 0 0 1 25 28H7a1.5 1.5 0 0 1-1.5-1.5v-21A1.5 1.5 0 0 1 7 4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillOpacity: .7,
			d: "M26.478 10.75H21.25a1.5 1.5 0 0 1-1.5-1.5V4.015l6.728 6.735Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M18.457 17.731a.3.3 0 0 1 0 .538l-4.274 2.115a.3.3 0 0 1-.433-.27v-4.229a.3.3 0 0 1 .433-.269l4.274 2.115Z"
		})
	]
});
export default SvgVideo;
